import React, { Fragment } from "react";
import Interaction, {InteractionType} from "./Interaction";
import {GetNewGuid} from "../../helpers/GuidHelper";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { ValidationHelper } from "../../features/validation/ValidationHelper";
import ShowLetterBoxNodePreview from "../../features/sequence/node_previews/ShowLetterBoxNodePreview";

export interface IShowLetterBox extends Interaction {
    color: {r: number, g: number, b: number, a: number};
    amount: number;
    animationTime: number;
}

export const showLetterBoxInteraction = (): InteractionFactoryEntity => {
    const component = <></>;

    const create = (getKeys: (amount: number) => string[]): IShowLetterBox => {
        return {
            id: GetNewGuid(),
            type: InteractionType.ShowLetterBox,
            name: "Show Letter Box",
            color: {r: 0, g: 0, b: 0, a: 1},
            amount: 0.2,
            animationTime: 0.5,
        };
    };

    const migrate = (
        from: number,
        to: number,
        interaction: Interaction
    ): IShowLetterBox => {
        return interaction as IShowLetterBox;
    };

    const copy = (
        interaction: Interaction,
        getKeys: (amount: number) => string[],
        replaceKey: (from: string, to: string) => void
    ): IShowLetterBox => {
        return {
            id: GetNewGuid(),
            type: InteractionType.ShowLetterBox,
            name: "Show Letter Box",
            color: (interaction as IShowLetterBox).color,
            amount: (interaction as IShowLetterBox).amount,
            animationTime: (interaction as IShowLetterBox).animationTime,
        };
    };

    const validate = (
        interaction: Interaction,
        getValue: (key: string) => string
    ): string[] => {
        const showLetterBox = interaction as IShowLetterBox;
        const warnings: string[] = [];

        return warnings;
    };

    const validateErrors = (interaction: Interaction): string[] => {
        const showLetterBox = interaction as IShowLetterBox;
        const errors: string[] = [];

        if (showLetterBox.amount < 0 || showLetterBox.amount > 1) {
            errors.push("Amount must be between 0 and 1");
        }

        if (showLetterBox.animationTime < 0) {
            errors.push("Animation time cannot be negative");
        }

        return errors;
    };

    const filter = (
        interaction: Interaction,
        takeName: string,
        getMatchingResults: (
            searchableStrings: string[],
            takeName: string,
            interaction: Interaction,
            filterType: string
        ) => SearchResultData[]
    ): SearchResultData[] => {
        const converted = interaction as IShowLetterBox;
        const searchableStrings: string[] = [interaction.name];

        return getMatchingResults(
            searchableStrings,
            takeName,
            interaction,
            filterType
        );
    };

    const filterType: string = "Show Letter Box";

    return {
        View: component,
        NodeView: (nodeId: string, interaction: Interaction) => (
            <ShowLetterBoxNodePreview nodeId={nodeId} interaction={interaction} />
        ),
        FilterType: filterType,
        Create: create,
        Migrate: migrate,
        Copy: copy,
        Validate: validate,
        ValidateErrors: validateErrors,
        Filter: filter,
    };
};
